import React from 'react'
const DeviceHandler =()=>{

    return(
        <>
        
        </>
    );	

}
export default DeviceHandler;

function Arr(props){
    let res = props.res
    return<div key={res[0]} className={`rowDeviceGDROW `} onClick={(e)=>{
        props.func1();
        props.func2(res)
    }}>
        <div className='GDheader'>
            <div className=''>{res[0]}</div>
            <div className-=''>{res[1]}</div>
        </div>
        <div className='GDcontent'>
            {/* <div className={` ${res[2]}`}></div> */}
            {res[3]==='測量中'? 
                <div className='fx-d-r fx-ccc'>
                    <div>{res[4]}</div>
                    {/* <div>{res[3]}</div> */}
                </div>
                :
                <div className='fx-ccc'>{res[3]}</div>}
        </div>
        <div className={`GDusingStatus ${res[2]}`}></div>

    </div>
}